import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgAirplane = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 66 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.65,
      d: "M61.758 18.273a4.19 4.19 0 0 0-.85.085 5.951 5.951 0 0 0-11.366 2.06 3.172 3.172 0 0 0-3.05 3.171c0 1.712 1.42 3.171 3.169 3.171h12.097c2.344 0 4.242-1.899 4.242-4.244a4.242 4.242 0 0 0-4.242-4.243ZM25.18 5.83A6.234 6.234 0 0 0 18.962 0a6.234 6.234 0 0 0-5.683 3.673A4.442 4.442 0 0 0 8 7.343h-.062a2.562 2.562 0 0 0 0 5.125h17.118a3.319 3.319 0 0 0 3.318-3.32A3.292 3.292 0 0 0 25.18 5.83Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "m63.735 13.577-2.071 1.231a27.732 27.732 0 0 1-3.084 1.59c-4.545 1.979-11.073 4.25-16.666 6.187l-12.012 3.462a75.708 75.708 0 0 1-8.533 1.263c-4.627.4-7.806.542-9.46.405l-.053-.005c-3.948-.339-4.596-3.335-4.696-4.242a.779.779 0 0 0-.2-.456l-4.775-4.616-1.91-1.847a.95.95 0 0 1-.256-.855.9.9 0 0 1 .545-.637l5.58-2.013a.817.817 0 0 1 .702.07l3 1.886 5.89 3.699c.097.06.208.08.3.038l14.211-5.132-6.32-3.519c-.733-.41-.648-1.494.143-1.78l6.1-2.217a.607.607 0 0 1 .366-.015l11.757 3.167 2.09-.749c1.846-.668 3.515-1.136 5.103-1.432l.398-.07a17.314 17.314 0 0 1 8.035.527c.63.194 1.25.421 1.86.684a.47.47 0 0 1 .136.062 18.859 18.859 0 0 1 3.98 2.351c.427.339.675.838.682 1.38-.011.607-.312 1.187-.837 1.585l-.005-.002Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.85,
      d: "m33.46 20.338-8.836 14.176c-.488.781.286 1.738 1.152 1.425l7.688-2.775c.355-.128.663-.355.892-.654l12.465-16.364c.305-.4-.1-.95-.573-.779L34.2 19.739a1.456 1.456 0 0 0-.74.599Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.75,
      d: "M30.245 13.603 42.292 9.24 30.534 6.074a.607.607 0 0 0-.367.017l-6.1 2.214c-.79.287-.878 1.371-.142 1.781l6.32 3.52v-.003Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "m61.32 8.945-4.947 2.216c-.65.291-1.396.3-2.054.024l-1.773-.744a.283.283 0 0 1-.007-.518l5.375-2.409c.63.194 1.25.422 1.86.685a.47.47 0 0 1 .136.061c.478.209.949.436 1.41.685Z",
      fill: "#65BFF1",
      opacity: 0.85
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "m9.844 14.998-7.659 3.396-1.91-1.848a.95.95 0 0 1-.256-.854.9.9 0 0 1 .545-.638l5.58-2.013a.817.817 0 0 1 .702.072l3 1.885h-.002Z",
      fill: "#65BFF1"
    }
  )
] });
const ForwardRef = forwardRef(SvgAirplane);
export {
  ForwardRef as default
};
